/**
 * External Dependencies
 */
import React, { useState } from 'react';
import classNames from 'classnames';

/**
 * Internal Dependencies
 */
import Button from 'components/button';
import Tooltip from 'components/tooltip';
import FormTextInput from 'components/forms/form-text-input';
import FormPasswordInput from 'components/forms/form-password-input';
import FormInputFloatingLabel from 'components/forms/form-input-floating-label';
import Card from 'components/card';
import Icon from 'components/icon';
import cscom from 'lib/customer-site-api';
import Preloader from 'components/preloader';

/**
 * Style dependencies
 */
import './styles.scss';

const SignInForm = () => {
	const [error, setError] = useState(null);
	const [values, setValues] = useState({ usernameOrEmail: '', password: '' });
	const [submitting, setSubmitting] = useState(false);

	const onSubmitForm = (e) => {
		e.preventDefault();
		loginUser();
	};

	const loginUser = async () => {
		const { usernameOrEmail, password } = values;

		setError(null);
		setSubmitting(true);

		return cscom
			.authentication()
			.login(usernameOrEmail, password)
			.then(({ token }) => {
				localStorage.setItem('currentUserJWT', token);
				window.location = '/login';
			})
			.catch((error) => {
				setError(error);
				setSubmitting(false);
			});
	};

	const onChangeField = (e) => {
		const { name, value } = e.target;
		setError(null);
		setValues({ ...values, [name]: value });
	};

	const signinStyles = classNames(['signin__form'], { 'login-form--has-error': !!error });

	return (
		<Card className='login-form'>
			<h3 className='login-form__heading'>Tower Advantage&trade; Login</h3>
			<form className={signinStyles} onSubmit={onSubmitForm}>
				<FormInputFloatingLabel
					label='Username'
					value={values.usernameOrEmail}
					FormInput={FormTextInput}
					name='usernameOrEmail'
					onChange={onChangeField}
				/>
				<FormInputFloatingLabel
					visible={values.visible}
					onChange={onChangeField}
					label='Password'
					name='password'
					value={values.password}
					FormInput={FormPasswordInput}
				/>
				{error && (
					<p className='help-text'>
						Sorry, username or password don't match.
						<br />
						<a className='font-weight-bold'><a href="//towersystems.com.au/login.html?view=reset">Forgot your password?</a></a>
					</p>
				)}
				<Button className='login-form__submit-btn' primary type='submit'>
					Log in
				</Button>
				<div className='signin-form__links'>
					<a
						className='signin-form__forgot-password'
						href='//towersystems.com.au/login.html?view=reset'
						data-tip='Forgot Password'
						data-for='forgotPassword'
					>
						Forgot your password?
					</a>
				</div>
			</form>
			{submitting && <Preloader />}
		</Card>
	);
};

export default SignInForm;
